import { subscribeNewsletter } from "api/newsletter";
import { Form, Formik } from "formik";
import { spacing } from "globalStyles";
import { useAppContext } from "providers/App";
import { NewsletterSection } from "interfaces/content";
import styled from "styled-components";
import { breakpoints } from "themes/breakpoints";
import Button from "ui/Button";
import FlexBox from "ui/FlexBox";
import CheckboxField from "ui/Input/form/CheckboxField";
import InputField from "ui/Input/form/InputField";
import Body from "ui/Text/Body";
import Heading from "ui/Text/Heading";
import { errorToast, successToast } from "ui/Toasts/Toast";
import * as Yup from "yup";
import { handleTextAndLinkType } from "../utils/content";

interface NewsletterProps {
  data: NewsletterSection["data"];
}

const Newsletter = ({ data }: NewsletterProps) => {
  const { setIsLoading } = useAppContext();

  const privacyPolicy = data.privacyPolicy;

  const parsedPrivacyPolicy = {
    ...privacyPolicy,
    href: `${process.env.REACT_APP_BASE_RELATIVE_ROUTES}/assets/${privacyPolicy.href}`,
  };

  const onSubmit = async ({ email }: { email: string; acceptedTerms: string }) => {
    setIsLoading(true);

    const { success } = await subscribeNewsletter(email, data.apiUrl);

    setIsLoading(false);

    if (!success) {
      errorToast({
        text: "Ocorreu um erro ao subscrever a newsletter",
        options: { autoClose: false },
      });
      return;
    }

    successToast({ text: "Subscrição realizada com sucesso" });
  };

  return (
    <Container id={data.id} className="anchor-offset">
      <div className="content-container">
        <Heading align="center" variant="h2" className="section-title" color="primary">
          {data.title}
        </Heading>
        <Heading align="center" variant="h5" color="secondary">
          {data.description}
        </Heading>
        <Formik
          initialValues={{
            email: "",
            acceptedTerms: "",
          }}
          validationSchema={Yup.object({
            email: Yup.string()
              .required("O campo deverá ser preenchido")
              .email("O campo é inválido"),
            acceptedTerms: Yup.boolean()
              .required("O campo deverá ser preenchido")
              .oneOf([true], "O campo deverá ser preenchido"),
          })}
          onSubmit={onSubmit}
        >
          <Form>
            <FlexBox className="mt-xl">
              <StyledInput type="email" name="email" placeholder="Email" />
              <Button type="submit">Subscrever</Button>
            </FlexBox>
            <CheckboxField
              className="mt-md"
              name="acceptedTerms"
              label={
                <Body variant="body6" color="secondary">
                  Li e aceito a {handleTextAndLinkType(parsedPrivacyPolicy)}
                </Body>
              }
            />
          </Form>
        </Formik>
      </div>
    </Container>
  );
};

export default Newsletter;

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

const StyledInput = styled(InputField)`
  margin-right: ${spacing.large}px;

  @media (max-width: ${breakpoints.md}) {
    margin-right: ${spacing.small}px;
  }
`;
